interface CongoPatternProps {
  variant?: 'pagne' | 'geometric' | 'triangles' | 'diamonds';
  className?: string;
}

export function CongoPattern({ variant = 'pagne', className = '' }: CongoPatternProps) {
  const patternClass = `pattern-${variant}`;
  
  return (
    <div 
      className={`absolute inset-0 pointer-events-none ${patternClass} ${className}`}
      aria-hidden="true"
    />
  );
}

export function CongoAccentBorder({ className = '' }: { className?: string }) {
  return (
    <div className={`accent-congo-border ${className}`} />
  );
}

export function CongoBorderTop({ className = '' }: { className?: string }) {
  return (
    <div className={`accent-pagne-top ${className}`} />
  );
}
